import { motion } from "framer-motion";
import { ShieldCheck, Award, Package, Truck } from "lucide-react";

/**
 * TrustStripBPI — compact reassurance band on the home, between MarqueeStats
 * and the products carousel. Surfaces the four hardest-to-fake B2B signals
 * (label BPI, brand depth, catalogue depth, logistic footprint) without
 * cannibalising the existing marquee. Stays subtle, no logo blob, no big
 * promise — just four anchored facts on one horizontal line.
 */
const ITEMS = [
  {
    icon: ShieldCheck,
    title: "BPI France Excellence",
    sub: "Label officiel d'État",
  },
  {
    icon: Award,
    title: "23 marques partenaires",
    sub: "Sélection grossiste",
  },
  {
    icon: Package,
    title: "300+ références",
    sub: "13 gammes complètes",
  },
  {
    icon: Truck,
    title: "Île-de-France · France",
    sub: "24h IDF · France selon zone",
  },
];

export const TrustStripBPI = () => (
  <section
    data-testid="trust-strip-bpi"
    className="relative bg-fd-elevated border-t border-fd-border py-10 md:py-14 px-6 md:px-10 lg:px-14"
  >
    <div className="max-w-[1400px] mx-auto">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-10">
        {ITEMS.map(({ icon: Icon, title, sub }, i) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: i * 0.08 }}
            className="flex items-start gap-3"
          >
            <div className="w-9 h-9 shrink-0 border border-fd-gold/40 flex items-center justify-center">
              <Icon size={16} className="text-fd-gold" />
            </div>
            <div className="min-w-0">
              <p className="font-display text-sm md:text-base uppercase tracking-tight leading-tight">{title}</p>
              <p className="mono-label !text-[10px] mt-1">{sub}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
